module.exports = __webpack_public_path__ + "static/media/Artwork1.522a591c.png";